<template>
  <div class="content">
    <el-row :gutter="24">
      <el-col :span="24" class="fix__top">
        <el-input
          prefix-icon="el-icon-search"
          class="style-fullWidth"
          size="medium"
          placeholder="Tìm kiếm theo tên/email/đơn vị/chức vụ"
          @keydown.enter.exact.native="searchTree"
          v-model="search"
        ></el-input>
      </el-col>
    </el-row>

    <VuePerfectScrollbar
      class="scroll-scope listCompanies"
      :settings="settings"
    >
      <el-tree
        :data="roots"
        :filter-node-method="filterTree"
        ref="departmentTree"
        class="filter-tree"
        default-expand-all
      >
        <div
          class="custom-tree-node flex-row flex__between width__100"
          slot-scope="{ node, data }"
        >
          <div class="field-1">
                <span>
                  <el-checkbox
                    v-model="data.checked"
                    @change="checkedChangeEvent(data)"
                  ></el-checkbox>
                  <span
                    v-if="
                      data.nodeType === DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
                    "
                  >
                    &nbsp;
                    <span class="font-weight__bold">
                      {{ data.userDeptRole.fullName }}
                    </span>
                    <span class="font-size__small font-italic">
                      ({{ data.userDeptRole.positionName }})
                    </span>
                  </span>
                  <span v-else>&nbsp;{{ getNodeLabel(data) }}</span>
                </span>
          </div>
        </div>
      </el-tree>
    </VuePerfectScrollbar>

  </div>
</template>

<script>
import constants from "../../../constants";
import buildShortNameFilter from "../../../filters/buildShortNameFilter";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import departmentService from "../../../services/departmentService";
import utils from "../../../services/utils";
import handlersTreeMixin from "../../../mixins/handlersTreeMixin";
import h from "../../../services/h";

export default {
  name: "bao-cao-tinh-hinh-xl-vb-receiver-select-tree",
  filters: {buildShortNameFilter},
  mixins: [handlersTreeMixin],
  components: {
    VuePerfectScrollbar
  },
  data() {
    return {
      DEPARTMENT_TREE: constants.DEPARTMENT_TREE,
      DEPARTMENT: constants.DEPARTMENT,
      GROUPS: constants.GROUPS,
      search: null,
      userDeptRoles: [],
      departments: [],
      settings: {maxScrollbarLength: 750},
    };
  },

  computed: {
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },

    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },

    deptId() {
      return this.$store.getters.userDeptRole
        ? this.$store.getters.userDeptRole.deptId
        : null;
    },

    roleCode() {
      return this.$store.getters.userDeptRole
        ? this.$store.getters.userDeptRole.roleCode
        : null;
    }
  },

  created() {
    this.initReceivers();
  },

  methods: {
    getToDepartments() {
      let toDepartments = [];
      let queue = [];
      queue.push(...this.roots);
      let index = 0;
      while (index < queue.length) {
        let data = queue[index];
        if (
          data.isHandlerNode &&
          data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT &&
          data.checked
        )
          toDepartments.push(data.department);
        queue.push(...(data.children || []));
        index++;
      }
      return toDepartments;
    },

    getToHandlers() {
      let toHandlers = [];
      let queue = [];
      queue.push(...this.roots);
      let index = 0;
      while (index < queue.length) {
        let data = queue[index];
        if (
          data.isHandlerNode &&
          data.nodeType ===
          constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE &&
          data.checked
        )
          toHandlers.push(data.userDeptRole);
        queue.push(...(data.children || []));
        index++;
      }
      return toHandlers;
    },

    collectCheckedReceiversData() {
      let toDepartmentIds =
        h.collect(this.getToDepartments(), item => item.id) || [];
      let toHandlerIds = h.collect(this.getToHandlers(), item => item.id) || [];
      return {
        toDepartmentIds: toDepartmentIds,
        toHandlerIds: toHandlerIds
      };
    },

    getNodeLabel(node) {
      return utils.getNodeLabel(node);
    },

    checkedChangeEvent(data) {
      this.checkedChange(
        data,
        data.isHandlerNode
          ? constants.PROCESS_TYPE.CHUTRI
          : this.defaultProcessType || constants.PROCESS_TYPE.NHANDEBIET
      );
    },

    checkedChange(data) {
      let checked = data.checked;
      if (data.isHandlerNode) {
        let nodeType = data.nodeType;
        switch (nodeType) {
          case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
          case constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE:
            break;
          default:
            break;
        }
      } else {
        this.checkedAllChildren(data, checked);
      }
      this.updateCheckedForParent(data);
    },

    checkedAllChildren(data, checked) {
      h.each(data.children, child => {
        let checkedState = child.checked || false;
        if (checkedState !== checked) {
          this.$set(child, "checked", checked);
          this.checkedChange(child);
        }
      });
    },

    updateCheckedForParent(data) {
      let parent = data.parent;
      if (!parent || parent.isHandlerNode) return;
      let currentCheckedState = parent.checked;
      let newCheckedState = !h.exists(parent.children, child => !child.checked);
      if (currentCheckedState !== newCheckedState) {
        this.$set(parent, "checked", newCheckedState);
        this.updateCheckedForParent(parent);
      }
    },

    searchTree() {
      this.$refs.departmentTree.filter(this.search);
    },

    filterTree(value, data) {
      switch (data.nodeType) {
        case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
          return utils.like(data.department.deptName, this.search);
        case constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE:
          return utils.isUserDeptRoleMatchWithQuery(
            data.userDeptRole,
            this.search
          );
        default:
          return false;
      }
    },

    initReceivers() {
      (this.roleCode === constants.ROLE.CODE.LANH_DAO
          ? this.loadDepartment()
          : Promise.resolve([])
      ).then(departments => {
        Promise.all([
          !departments || !departments.length
            ? this.loadUserDeptRoles()
            : Promise.resolve([]),
          this.roleCode === constants.ROLE.CODE.LANH_DAO
            ? this.loadDepartment()
            : Promise.resolve(departments)
        ]).then(results => {
          let userDeptRoles = results[0];
          let departments = results[1];
          this.userDeptRoleHandlers = userDeptRoles;
          this.departmentHandlers = departments;
          this.buildNodes();
        });
      });
    },

    loadUserDeptRoles() {
      return userDeptRoleViewService
        .findAllForBaoCaoTinhHinhXLVb()
        .then(response => response.data);
    },

    loadDepartment() {
      return departmentService
        .findAllActiveDeptsByParentId(this.deptId)
        .then(response => response.data);
    }
  }
};
</script>

<style scoped>
.select-Unit-BanHanh .content {
  padding: 10px 15px;
  padding-bottom: 0;
  /*border: 1px solid #ceced2;*/
  border-radius: 4px;
}

.select-Unit-BanHanh .label {
  color: #2d3e4f;
  font-size: 12px;
  line-height: 20px;
  margin-bottom: 10px;
  margin-top: 7px;
}

.select-Unit-BanHanh .content .listCompanies.scroll-scope {
  margin-top: 5px;
  /*height: 100%;*/
  height: calc(100vh - 200px);
  position: relative;
  margin-bottom: 10px;
  width: 100%;
}

.select-Unit-BanHanh .content .listCompanies .company_item {
  margin: 10px 0;
}

.select-Unit-BanHanh .content .listCompanies .company_item .name {
  color: #2d3e4f;
  font-weight: 700;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 25px;
}

</style>



// WEBPACK FOOTER //
// src/views/report/incomingDoc/bao-cao-tinh-hinh-xl-vb-receiver-select-tree.vue